import { ApiClient } from '@member-portal/api-client';
import { TOKEN_KEY, SALESFORCE_TOKEN_KEY } from '@/contexts/AuthContext';

/**
 * Build auth headers from tokens stored by AuthContext (same localStorage keys).
 * Used so API requests work outside React components and stay in sync with AuthContext.
 */
function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const jwtToken = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;
  const salesforceToken =
    typeof window !== 'undefined' ? localStorage.getItem(SALESFORCE_TOKEN_KEY) : null;
  if (jwtToken) {
    headers['Authorization'] = `Bearer ${jwtToken}`;
  }
  if (salesforceToken) {
    headers['X-Salesforce-Token'] = salesforceToken;
  }
  return headers;
}

/**
 * Makes an authenticated request using JWT and Salesforce token from AuthContext storage.
 */
function makeAuthenticatedRequest(url: string, options: RequestInit = {}): Promise<Response> {
  const headers = getAuthHeaders();
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...(options.headers as Record<string, string>),
    },
  });
}

// Extended client with app-specific methods if needed later
class FhxdApiClient extends ApiClient {
  constructor() {
    super({
      baseUrl: '',
      getAuthenticatedRequest: () => makeAuthenticatedRequest,
    });
  }
}

export const apiClient = new FhxdApiClient();
